import React from 'react'
import PropTypes from 'prop-types'

import { Icon as Iconify } from '@iconify/react'
import { cookie } from '@utils'
import { ssoFederatedLogout } from '@utils/sso-redirect'

import destroySession from '@graphql/mutators/destroy-session'
import { refreshCsrf } from '@utils/csrf-bootstrap'

const UserBox = ({ user }) => {
  const userInitials = user.fullName.split(' ')[0].substring(0, 1) + user.fullName.split(' ')[1].substring(0, 1)

  const handleLogout = () => {
    const finishLocal = async () => {
      cookie.set('csrfCookie', 0, -1)
      localStorage.clear()
      const redirected = await ssoFederatedLogout()
      if (!redirected) {
        // Full reload: destroySession tears down the Apollo client, so an SPA nav to /login can't refetch auth and hangs on the loader.
        window.location.assign('/login')
      }
    }
    const run = () => destroySession().then(finishLocal)
    refreshCsrf().catch(() => {}).then(run)
      .catch((err) => (err?.networkError?.statusCode === 403 ? refreshCsrf().catch(() => {}).then(run) : Promise.reject(err)))
      // Logout must never trap the user: tear down locally even if the server call fails.
      .catch(() => finishLocal())
  }

  return (
    <>
      <div className='user-box-contain'>
        <div className='user-box-popup'>
          <div className='user-box-circle'>
            <div>{userInitials}</div>
          </div>
          <p className='user-name'>{user.fullName}</p>
          <p className='user-email'>{user.email}</p>
          <div className='user-role'><p>{user.systemRole?.name}</p></div>
          <ul>
            {/* SSO users have no alcatraz password — theirs lives in Auth0. */}
            {!user?.isSsoUser && (
              <li><a href='/change-password'><Iconify width='20px' icon='teenyicons:password-solid' /><span>Change Password</span></a></li>
            )}
            <li><a onClick={handleLogout}><Iconify icon='ion:log-out-sharp' /><span>Logout</span></a></li>
          </ul>
        </div>
      </div>
    </>
  )
}

UserBox.propTypes = {
  user: PropTypes.object
}

export default UserBox
